/**
 * Created by calhosh on 10/14/2024
 */
import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import ToastMessage from './StyledToastMessage';
import {setFormV2ToasterVisibility} from '../../../actions/Toast/toastactions';
import {clearErrors} from '../../../actions/erroractions';

export default function ToastMessageContainer(props) {
	const {className, toastClassName, toastFeature} = props;

	const dispatch = useDispatch();

	const toastMessageDetails = useSelector((state) => state.toasterDetails);
	const {showToaster, toasterVariant, toasterDescription, feature, timeout} = toastMessageDetails;

	const handleOnClose = useCallback(() => {
		dispatch(setFormV2ToasterVisibility(false));
		dispatch(clearErrors());
	}, [dispatch]);

	useEffect(() => {
		if (timeout > 0) {
			const timer = setTimeout(() => {
				dispatch(setFormV2ToasterVisibility(false));
			}, timeout);

			// Cleanup the timer if the component unmounts or timeout changes
			return () => clearTimeout(timer);
		}
	}, [timeout, dispatch]);

	return (
		<StyledToastMessageContainer className={`StyledToastMessageContainer${className ? ' ' + className : ''}`}>
			{showToaster && (
				<ToastMessage
					className={`StyledToastMessage${toastClassName ? ' ' + toastClassName : ''}`}
					variant={toasterVariant}
					onClose={handleOnClose}
				>
					{toasterDescription}
				</ToastMessage>
			)}
		</StyledToastMessageContainer>
	);
}

const StyledToastMessageContainer = styled.section`
	z-index: 11;
	position: absolute;
	width: calc(100% - var(--px-80));
	left: var(--px-40);
	top: var(--px-6);
`;
